const QUICK_REPLY_EVENT = 'nutriplus-dashboard-app:insert-quick-reply';
const MAX_QUICK_REPLY_LENGTH = 4000;

export const parseNutriplusQuickReply = value => {
  let payload = value;

  if (typeof value === 'string') {
    if (value.length > MAX_QUICK_REPLY_LENGTH + 256) return null;
    try {
      payload = JSON.parse(value);
    } catch {
      return null;
    }
  }

  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
    return null;
  }

  if (payload.event !== QUICK_REPLY_EVENT) return null;

  const text = payload.data?.text;
  if (typeof text !== 'string') return null;

  const normalized = text.trim();
  if (!normalized || normalized.length > MAX_QUICK_REPLY_LENGTH) return null;

  return normalized;
};

export { QUICK_REPLY_EVENT, MAX_QUICK_REPLY_LENGTH };
